import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ReferenceInput } from "react-admin";
import { QuickCreate } from "./QuickCreate";
import { ReferenceCreateInputContainer } from "./ReferenceCreateInput.styled";
export const ReferenceCreateInput = ({ children, dialogChildren, label, isTemplate, ...props }) => {
    return (_jsxs(ReferenceCreateInputContainer, { children: [_jsx(ReferenceInput, { ...props, children: React.cloneElement(children, { label }) }), _jsx(QuickCreate, { source: props.source, reference: props.reference, children: dialogChildren })] }));
};
